export default __webpack_public_path__ + "static/media/mobile_reward1_detail_2Big.7fa2dd09.png";